'use client';

import Link from 'next/link';
import React from 'react';

const articles = [
    {
        title: 'Next.js Render Methods: SEO Optimization Deep Dive',
        href: '/articles/diving-deeper-into-nextjs-render-methods-optimizing-page-rendering-for-seo-success',
        source: 'SEOZast',
    },
    {
        title: 'Automation in SEOZast: Streamline Your SEO',
        href: '/articles/the-power-of-automation-in-seozast-how-to-streamline-your-seo-efforts',
        source: 'SEOZast',
    },
    {
        title: '7 Tips for Choosing the Best Dive Center',
        href: 'https://www.beunderwater.com/articles/7-tips-for-choosing-the-best-dive-center-for-your-next-adventure',
        source: 'Be Underwater',
    },
    {
        title: '10 Best Diving Spots in Southeast Asia',
        href: 'https://www.beunderwater.com/articles/10-best-diving-spots-in-southeast-asia-for-beginners',
        source: 'Be Underwater',
    },
];

const SampleArticles = () => {
    return (
        <div className="border-t border-gray-200 py-10 mb-6 text-center sm:px-1 px-2">
            <h2 className="text-3xl font-bold text-center mb-6">Sample Articles Created with SEOZast</h2>
            <p className="text-gray-700 mb-6">
                All generated in minutes using real data and optimized for SEO and AI search.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto text-left">
                {articles.map((article, i) => (
                    <Link
                        key={i}
                        href={article.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block p-4 rounded-lg border border-gray-200 hover:border-emerald-600 hover:shadow transition"
                    >
                        <h4 className="text-emerald-700 font-semibold mb-1">{article.title}</h4>
                        <p className="text-sm text-gray-600 italic">{article.source}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default SampleArticles;
